




















































































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import MailboxVerificationZohoConfirmationCodeFinder from './mailbox-verification-zoho-confirmation-code-finder.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'MailboxVerificationInstructionsZoho',
  components: {
    MailboxVerificationZohoConfirmationCodeFinder,
  },
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ColorAssistant,
      curStep: 1,
      stepCount: 7,
      emailCopied: false,
    }
  },
  computed: {
    stepPercentage(): Number {
      return Math.round(((this.curStep - 1) / (this.stepCount - 1)) * 100)
    },
    isConfirmationEmailStep(): boolean {
      return this.curStep === 6
    },
  },
  methods: {
    updateStep(curItem: any) {
      this.curStep = curItem + 1
      // Reset copied email...
      this.emailCopied = false
    },
    goToNextItem() {
      // @ts-ignore
      this.$refs.carousel.setActiveItem(this.curStep)
    },
    goToPrevItem() {
      // @ts-ignore
      this.$refs.carousel.setActiveItem(this.curStep - 2)
    },
    goToFirstItem() {
      // @ts-ignore
      this.$refs.carousel.setActiveItem(0)
    },
  },
})
